"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const theme = {
  colorActive: 'interactive.primary.active',
  colorChecked: 'interactive.primary.default',
  colorDisabled: 'disabled.2',
  color: 'interactive.ui.active',
  inputSize: 22
};
exports.theme = theme;
//# sourceMappingURL=Radio.theme.js.map